import Konva from 'konva';

export class ScaleTransformer extends Konva.Transformer {
  constructor(config?: Konva.TransformerConfig) {
    super({
      ...config,
      id: 'scale-transformer',
      flipEnabled: false,
      borderStrokeWidth: 1,
    });
  }
}
